import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { PoliticalSpendingReportColumns, IEReportItemsColumns, IEReportColumns, IEPacReportColumns, BallotQuestionSpendingReportColumns, ElectioneeringCommunicationReportColumns } from '../../../types/referenceData/reportTableColumns';
import IePacReport from '../../../types/reports/iePacReport';
import IndependentExpenditureItem from '../../../types/reports/independentExpenditureItem';
import MiscReportContent from '../../../types/reports/miscReportContent';

interface Props {
    tableRows?: IndependentExpenditureItem[] | IePacReport[] | MiscReportContent[];
    type: string;
}

const IndependentSpendingReportsTable = (props: Props): JSX.Element => {
    let col;
    switch (props.type) {
        case 'ieItems': {
            col = IEReportItemsColumns;
            break;
        }
        case 'iePac': {
            col = IEPacReportColumns;
            break;
        }
         case 'bqSpending': { 
            col = BallotQuestionSpendingReportColumns;
            break; 
         } 
         case 'ecReports': {
          col = ElectioneeringCommunicationReportColumns;
          break;
         }
         case 'psr': {
          col = PoliticalSpendingReportColumns;
          break;
         }
         default: {  // default to ieReports
            col = IEReportColumns;
            break; 
         } 

    }
    return (
        <Box 
        sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        maxWidth: '100%',
        '.MuiDataGrid-columnHeaderTitle': { 
            fontWeight: 'bold !important',
        },
        }}>
        <DataGrid 
            rows={props.tableRows}
            columnVisibilityModel={{
              filed: false,
            }}
            getRowHeight={() => 'auto'}
            columns={col}
            getRowId={(row) => row.id}
            disableColumnMenu
            disableRowSelectionOnClick
            hideFooterSelectedRowCount
            sx={{ 
              '.MuiDataGrid-cell': {
                whiteSpace: 'normal', 
                wordBreak: 'break-word',
                paddingTop: '3px!important',
                paddingBottom: '3px!important',
              },
            }}
        />
      </Box>
    );
}

export default IndependentSpendingReportsTable;